module.exports = __webpack_public_path__ + "static/media/insight_desc1.37b7989a.png";